import { gql } from '@apollo/client';

export const PROPERTY_BROKERS_FRAGMENT = gql`
  fragment PropertyBrokers on Property {
    brokers {
      list {
        id
        name
        title
        phone
        cellphone
        email
        office {
          info {
            name
            urltag
          }
        }
        image {
          full
        }
        path
      }
    }
  }
`;
